/**
 * Validates the text layout of the email.
 * @param {string} email
 * @return {boolean}
 */
export function validateEmail(email) {
    return () => {
        return (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9æøåäöÆàéèêóÒôØÅÄÖÀÉÈÊÓÒÔ]+\.)+[a-zA-ZæøåäöÆàéèêóÒôØÅÄÖÀÉÈÊÓÒÔ]{2,}))$/).test(email);
    };
}
/**
 * Validates Customer number.
 * @param {string} cusNo
 * @return {boolean}
 */
export function validateCusNo(cusNo) {
    return () => {
        return cusNo && cusNo.length===5;
    };
}

/**
 * Returns true if following is met
 * Atleast 8 character long
 * Atleast 1 upper case
 * Atleast 1 lower case
 * Atleast 1 number
 * @param {string} password 
 * @returns {func}
 */
export function validatePassword(password) {
    return () => {
        //test length
        if(password==null || password.length<8){
            return false;
        }
        //has upper case
        if( !password.match(/[A-ZØÅÄÖÀÉÈÊÓÒÔ]/g) ){
            return false;
        }
        //has lower case
        if( !password.match(/[a-zæøåäöÆàéèêóÒô]/g) ){
            return false;
        }
        //has number
        if( !password.match(/[0-9]/g) ){
            return false;
        }
        return true;
    };
}